import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from 'react-router-dom'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';

import Dashboard from './scenes/Dashboard';
import Login from './scenes/Login';
import NotFound from './scenes/NotFound';

import { auth, storageKey, isAuthenticated } from './config/firebase';

const theme = createMuiTheme({
  palette: {
    primary: blue,
  },
});

class App extends Component {
  constructor(props) {
    super(props)

    this.state = {
      user: null
    }
  }

  componentWillMount() {
    auth.onAuthStateChanged(user => {
      if (user) {
        let userData = {
          uid: user.uid,
          email: user.email,
          photoURL: user.providerData[0].photoURL,
          name: user.providerData[0].displayName,
        }

        window.localStorage.setItem(storageKey, user.uid);
        this.setState({user: userData});
      } else {
        window.localStorage.removeItem(storageKey);
        this.setState({user: null});
      }
    });
  }

  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <Router>
          <Switch>
            <Route path='/login' component={Login}/>
            <Route path='/404' component={NotFound}/>
            <Route exact path='/' component={() => (<Redirect to='/resources'/>)} />
            <PrivateRoute path='/:screen/:postId?/:visibility?' component={({match}) => (<Dashboard user={this.state.user} matchParams={match.params} />)}/>
            <Route component={NotFound}/>
          </Switch>
        </Router>
      </MuiThemeProvider>
    );
  }
}

const PrivateRoute = ({ component, ...rest }) => (
  <Route {...rest} render={props => (
    isAuthenticated() ? (
      React.createElement(component, props)
    ) : (
      <Redirect to={{
        pathname: '/login',
        state: { from: props.location }
      }}/>
    )
  )}/>
)

export default App;



// WEBPACK FOOTER //
// ./src/App.js